import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';
import { useWhatsAppConnectionWizardContext } from './WhatsAppConnectionWizard.context';
import type { tWhatsAppConnectionWizardHook } from './WhatsAppConnectionWizard.types';

/**
 * State and actions of the WhatsApp API connection wizard: whether its modal
 * is open, plus the connection state, chosen path, moment and actions that
 * `WhatsAppConnectionWizardProvider` holds across modal closes.
 *
 * The connection analytics and the refetch on success live in the provider,
 * a single instance, so they run once however many components read this.
 *
 * @returns {tWhatsAppConnectionWizardHook | null} What the wizard renders and
 * acts on, or null until the provider has published its state.
 */
export function useWhatsAppConnectionWizard(): tWhatsAppConnectionWizardHook | null {
  const {
    whatsAppBusinessConnectionModalIsOpen,
    whatsAppBusinessConnectionModalIsLegacyChosen,
  } = useModalsContext();
  const wizardContext = useWhatsAppConnectionWizardContext();

  if (!wizardContext) return null;
  // Leaving for the current modal keeps the modal open, so the wizard reads
  // itself closed and fades out while the current modal enters.
  return {
    ...wizardContext,
    isOpen:
      whatsAppBusinessConnectionModalIsOpen &&
      !whatsAppBusinessConnectionModalIsLegacyChosen,
  };
}
